export default __webpack_public_path__ + "static/media/chooseMaltoBuza.35d513e4.png";